import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"

import { initiateSectionRetake } from "../requesters/CalculatorResultsRequester"

// Starts a single-section PQ Index retake: POST /calculator_results/section_retake,
// then redirect to the questionnaire scoped to that section. Shared by the
// dashboard's SectionRetakeButton and the overview page's SectionRetakeDropdown so
// the two entry points can't drift (response shape, query params, error copy).
//
// Returns:
//   startRetake(section) — guarded initiator (no-op when inactive or already busy)
//   inflightSection      — the section currently starting, or null when idle
//   busy                 — boolean form of the above, for single-button callers
//   isActive             — whether the enrolment can retake
export default function useSectionRetake(baseUrl, enrolment) {
  const navigate = useNavigate()
  const [inflightSection, setInflightSection] = useState(null)

  const isActive = enrolment?.status === "active"
  const busy = inflightSection !== null

  const startRetake = section => {
    if (!isActive || busy) return

    setInflightSection(section)
    initiateSectionRetake(baseUrl, enrolment.id, section).then(res => {
      const resultId = res?.response?.calculator_result_id
      if (!resultId) throw new Error("Missing calculator_result_id in retake response")

      const query = new URLSearchParams({ retake_result_id: resultId, section })
      navigate(`/livelife/questions?${query}`)
      return null
    }).catch(() => {
      setInflightSection(null)
      toast.error("We couldn't start your retake. Please try again.")
    })
  }

  return {
    startRetake, inflightSection, busy, isActive
  }
}
